var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "233px",
    height: "31px",
    viewBox: "0 0 233 31",
    enableBackground: "new 0 0 233 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 233,
    height: 31,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAAAfAgMAAAB/kgJ0AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUAAAADLHWIy/3///8E eSTRAAAAAnRSTlMA/MKYcw8AAAABYktHRAMRDEzyAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJ TUUH5gkREQ0dIjDbZwAAAadJREFUOMvtlE2OwyAMhWEkNl3Hl8gp3EX3jITv06NkWeWU4/eATvPX n1kPUpsA/mzybBPCZqRwOKKuzMSWBqIHpJWUl2bRTFfsfuRktmbTlt2PLFtW3mVty1qWNbt75mi6 Zn1pZXqgVbIwbNgHyZ+yxX9LFktwIGfz13Qp9cySPYpv2d27r4A93cLggaKBzZRQ5eJaQDhq5YkL 5omP5r4s33OSwzwHmDA7cOcSZqd8CtHBYgu+EnxYocxkv+b5SvdkleWxz2IeO4tvzqfGYpPuon+q mBSnimSw+Defmw7RYpOE7G2cyCpYShgLSUQki+hIvO/GUuUsZMfpNFFYHLi6iz1eZ+kaJr5JrTp7 rWxZsLrHIqfff2FDZY35PWCHF2zpbF6zXgcvWK2t4JL+stRKcjIsdlaazqbVBJUptTYE7DReuYEc efYLa6OSrTb8mVsJRKsf7I9ca0Na4UCKHDqhvZ53WBCsSb6xJnldoXLDI5sam9gLpfavsZ5vvKXq TcXeKu2+QM8k9LKdtbaadrHYjhrGieGiXRbNHZ7cr2+Mf/b9kT4x/gGFqbqAN3ErQwAAACV0RVh0 ZGF0ZTpjcmVhdGUAMjAyMi0wOS0xN1QxNzoxMzoyOSswMDowMJuowNoAAAAldEVYdGRhdGU6bW9k aWZ5ADIwMjItMDktMTdUMTc6MTM6MjkrMDA6MDDq9XhmAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAy MDIyLTA5LTE3VDE3OjEzOjI5KzAwOjAwveBZuQAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd2ff7b872b0bf163508664e4c89d67d.svg";
export { ForwardRef as ReactComponent };